import React from 'react'
import { render } from 'react-dom'
import { ConfigProvider } from 'antd'
import { ChannelConfigHS } from 'src/commons/store/BasisStore'
import { GetChannel } from 'src/commons/utils'
import { reportClientOpenHS } from 'src/commons/store/BasisStore'
import Login from './login'
import axios from 'axios'
import './index.css'
import ProtocolModal from 'src/pc/components/protocol-modal'
import CEFTransfer from 'src/commons/utils/CEFTransfer'
import zhCN from 'antd/lib/locale-provider/zh_CN'

axios.defaults.withCredentials = true
axios.defaults.headers = {
  Platform: 'simple',
  box: !!window.FuluApp,
  'Cache-Control': 'cache',
  terminal: 'pc',
  'front-version': '2.0.0',
}
CEFTransfer()
reportClientOpenHS.Execute({ channel: GetChannel() })
ChannelConfigHS.Execute({ channel: GetChannel(), product: 'hsgj' })
render(
  <ConfigProvider locale={zhCN}>
    <Login />
    <ProtocolModal width={500} height={260} />
  </ConfigProvider>,
  document.getElementById('root'),
)
